import Script from "next/script"

const DATADOME_KEY = process.env.NEXT_PUBLIC_DATADOME_KEY
const DATADOME_DOMAIN = process.env.NEXT_PUBLIC_SERASA_API_DOMAIN

const DataDomeScript = () => (
  <Script
    id="gtm-data-dome"
    strategy="afterInteractive"
  >
    {`!function(a,b,c,d,e,f){a.ddjskey=e;a.ddoptions=f||null;var m=b.createElement(c),n=b.getElementsByTagName(c)[0];m.async=1,m.src=d,n.parentNode.insertBefore(m,n)}(window,document,"script","https://js.datadome.co/tags.js","${DATADOME_KEY}", { ajaxListenerPath : '${DATADOME_DOMAIN}', allowHtmlContentTypeOnCaptcha : true});`}
  </Script>
)

export default DataDomeScript
